import React, { useEffect } from 'react';
import { RuleType } from '@loyalty/shared-common/rule-api-client';
import { EarningRulesTable } from '../../libs/earning-rules/EarningRulesTable';
import { IncomingWebhooksProvider } from '../../libs/program-incoming-webhooks/IncomingWebhookContext';
import { QlfMasterDetailContainer } from '../../libs/shared/layout/QlfMasterDetailContainer';
import { useCustomKeys } from '../../libs/custom-keys/CustomKeysContext';
import { useRules } from '../../libs/rules/RulesContext';

export function EarningRulesIndexPage(): React.ReactElement {
  const { earningRules, fetchRules } = useRules();
  const { customKeys, getCustomKeys } = useCustomKeys();

  useEffect(() => {
    if (!earningRules) {
      fetchRules(RuleType.EARN);
    }
    if (!customKeys) {
      getCustomKeys();
    }
    // eslint-disable-next-line
  }, []);

  return (
    <IncomingWebhooksProvider>
      <QlfMasterDetailContainer>
        <EarningRulesTable />
      </QlfMasterDetailContainer>
    </IncomingWebhooksProvider>
  );
}
